// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cVQE","label":"styles_label__1AIC7"};